/* ══════════════════════════════════════
   ORÉA — Thème Shopify Custom JS
   ══════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  // ── NAV SCROLL EFFECT ──
  const nav = document.querySelector('.orea-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  // ── HAMBURGER MENU (mobile) ──
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileMenu = document.querySelector('.nav-mobile');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
    });
  }

  // ── AUTO-SCROLL CAROUSELS ──
  document.querySelectorAll('[data-carousel]').forEach(block => {
    const track = block.querySelector('.carousel-track');
    const wrap  = block.querySelector('.carousel-track-wrap');
    if (!track) return;

    // Clone cards for seamless infinite loop
    const cards = Array.from(track.children);
    cards.forEach(card => track.appendChild(card.cloneNode(true)));

    let pos = 0;
    const speed = 0.5;
    let paused = false;

    function step() {
      if (!paused) {
        pos += speed;
        const half = track.scrollWidth / 2;
        if (pos >= half) pos -= half;
        track.style.transform = `translateX(-${pos}px)`;
      }
      requestAnimationFrame(step);
    }

    wrap.addEventListener('mouseenter', () => paused = true);
    wrap.addEventListener('mouseleave', () => paused = false);
    wrap.addEventListener('touchstart', () => paused = true, { passive: true });
    wrap.addEventListener('touchend', () => setTimeout(() => paused = false, 1200));

    requestAnimationFrame(step);
  });

  // ── ADD TO CART (Shopify AJAX) ──
  document.querySelectorAll('.product-quick-add[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      const originalText = this.textContent;
      this.textContent = '...';
      this.disabled = true;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        this.textContent = '✓ Ajouté';
        updateCartCount();
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
        }, 2000);
      } catch (err) {
        this.textContent = 'Erreur';
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
        }, 2000);
      }
    });
  });

  // ── UPDATE CART COUNT IN NAV ──
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.querySelector('.cart-count');
      if (badge) badge.textContent = cart.item_count;
    } catch (e) {}
  }

  updateCartCount();

  // ── NEWSLETTER FORM ──
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = this.querySelector('.newsletter-input');
      const btn   = this.querySelector('.newsletter-btn');
      if (!input.value) return;
      btn.textContent = 'Inscrit ✓';
      input.value = '';
      setTimeout(() => btn.textContent = "S'inscrire", 3000);
    });
  }

});
